import produce from "immer";
import { useCallback, useEffect, useReducer } from "react";
import { reducer } from "./BulkBaseIndexControl.reducer";
import { BulkBaseIndexControlDateRange } from "./BulkBaseIndexControl.types";
import type { IBulkBaseIndexControlProps, IBulkBaseIndexControlState } from "./BulkBaseIndexControl.types";
import { useDictionary } from "../../../../../../../reportng";
import { dictionaryService } from "../../../../../../../reportng/dataFlow";
import { useBulkExportFavouriteQueryParams } from "../../../../../../shared/hooks/useBulkExportFavouriteQueryParams";
import { useBulkExportContext } from "../../../../../../providers";

const initialState: IBulkBaseIndexControlState = {
  lastCalendar: {},
  availableDateRanges: [],
  selectedRanges: [],
  selection: [],
  value: {},
  items: {
    [BulkBaseIndexControlDateRange.Annual]: [],
    [BulkBaseIndexControlDateRange.Quarter]: [],
    [BulkBaseIndexControlDateRange.Month]: [],
    [BulkBaseIndexControlDateRange.Week]: [],
  },
};

export function useBulkBaseIndexControl<T extends number | string | unknown = unknown>(props: IBulkBaseIndexControlProps) {
  const { items: propsItems, availableDateRanges, onChange, dataSourceId, selection, isBulkSubscribtion } = props;
  // FIXME selection
  //TODO: Убрать данное легаси, заменить на reqct-query
  const [lastCalendarItems] = useDictionary(dictionaryService, "f-last-calendar-bulk", undefined, {
    p_source: Number(dataSourceId),
  });

  const { favoriteBulkId } = useBulkExportFavouriteQueryParams();
  const bulkExportContext = useBulkExportContext();
  const tab = bulkExportContext?.state.tab;
  const currentSavedSettings = bulkExportContext?.state.currentSavedSettings;
  const dimensions = bulkExportContext?.state.dimensions;
  const isCurrentFavouriteSettings = bulkExportContext?.state?.currentFavouriteSettings?.id;

  const [state, dispatch] = useReducer(reducer, initialState as IBulkBaseIndexControlState<T>, () =>
    produce(initialState, (draft) => {
      draft.availableDateRanges = availableDateRanges;
      draft.selectedRanges = [availableDateRanges[0]];
    })
  );

  useEffect(() => {
    const controlValue = state.selectedRanges.flatMap((dateRange) => {
      const value = state.value[dateRange];
      const items = state.items[dateRange];

      const dateRangeValues = items?.filter((it) => Number(it.id) === Number(value)).map((it) => it.id) || [];
      return dateRangeValues as (string | number)[];
    });

    if (controlValue.length) {
      onChange?.(controlValue);
    }
  }, [state]);

  useEffect(
    function initItems() {
      let selected: string | number | undefined;

      if (state.selection.length > 0) {
        selected = state.selection[0];
      } else if (isBulkSubscribtion) {
        selected = dimensions?.find((el) => el.id === "base_index.default")?.selection[0];
      } else if(isCurrentFavouriteSettings) {
        selected = bulkExportContext?.state.currentFavouriteSettings?.mark?.parameters?.dimensions.find((el) => el.id === "base_index.default")?.selection[0];
      } else {
        selected = currentSavedSettings?.dimensions.find((el) => el.id === "base_index.default")?.selection[0];
      }
      const savedDateRange: BulkBaseIndexControlDateRange | undefined = selected ? Number(`${selected}`[0]) : undefined;

      if (propsItems.length) {
        dispatch({
          type: "initItems",
          payload: {
            value: {
              items: propsItems,
              lastCalendarItems: lastCalendarItems ?? [],
              isBulkSubscribtion,
              savedDateRange,
              selection: selected,
              favoriteBulkId,
              tab,
              isCurrentFavouriteSettings,
            },
          },
        });
      }
    },
    [
      propsItems,
      lastCalendarItems,
      isBulkSubscribtion,
      favoriteBulkId,
      tab,
      isCurrentFavouriteSettings,
      currentSavedSettings?.dimensions
    ]
  );

  const onChangeValueHander = useCallback((dateRange: BulkBaseIndexControlDateRange, value: T) => {
    dispatch({ type: "changeValue", payload: { dateRange, value } });
  }, []);
  const onChangeCheckedHander = useCallback((dateRange: BulkBaseIndexControlDateRange, checked: boolean) => {
    dispatch({ type: "toggleDateRange", payload: { dateRange, value: checked } });
  }, []);

  return {
    state: state as IBulkBaseIndexControlState<T>,
    onChangeValueHander,
    onChangeCheckedHander,
  };
}
